<div class="row puertaTitulo">
	<p class="Labels">{{ modelService.getString('conf_puerta') }}</p>
</div>

<div class="configuracion">

	<div #holder class="carousel">
		<ul #contents>
			<li *ngFor="let currentItem of listadoModelosPuertas; let i = index;">
				<div #itemView class="settings-item" [class.selected]="currentItem._id === data.idModeloPuerta"
					(click)="recuperaTiposPuertas(currentItem, i)">

					<div class="category-details">
						<h3 [attr.title]="currentItem.desc[modelService.getLanguage().currentLanguage]">
							<a>{{currentItem.desc[modelService.getLanguage().currentLanguage]}}</a>
						</h3>
						<span class="bg" [ngStyle]="{'background-color':currentItem.background}"></span>
					</div>

					<div class="category-image">
						<img src="./assets/img/catalog/{{ currentItem.idUnity }}.jpg"
							alt="{{ currentItem.desc[modelService.getLanguage().currentLanguage] }}" />
					</div>
				</div>

			</li>
		</ul>
	</div>
<!--  ########### ESPRIVISA-43 ############## -->
	<div class="row">
		<div class="col-lg-6">
			<label for="optMedidaMalla">{{ modelService.getString('builder_door_properties') }}</label>
			<select class="custom-select" id="optPropiedadesPuerta" [disabled]="listadoPuertas.length===0 || isDisabled"
				[(ngModel)]="data.idPuerta" (ngModelChange)="seleccionaPuerta()" (focus)="clickSeleccionaPuerta()" (click)="selecctionPuerta(data.idPuerta)">
				<option [ngValue]="undefined">{{ modelService.getString('builder_door_properties_select') }} </option>
				<option  class="puerta" *ngFor="let puerta of listadoPuertas" [ngValue]="puerta._id"> {{ puerta.medidas }}&nbsp;cm,
					{{puerta.hojas}}&nbsp;{{puerta.hojas == 1 ? modelService.getString('builder_door_leave') : modelService.getString('builder_door_leaves')}}</option>
			</select>
<!--  ########### ESPRIVISA-43 ############## -->
		</div>
		<div class="col-lg-2">&nbsp;</div>
		<div class="col-lg-4 no-gutters" style="text-align: right;">
			<label for="optBorrarPuerta">&nbsp;</label>
			<button class="btn btnBorrarDoor" [disabled]="isDisabled" (click)="eliminaPuerta()"><i class="fa fa-trash"
					aria-hidden="true"></i>{{modelService.getString('builder_delete_door')}}</button>
		</div>
<!-- ESPRIVISA-36 -->
		<div class="row pdfContainer mt-4">
			<div class="col-sm-3 pdf-download" (click)="downloadModelPDF()">
				<i class="fa fa-file-pdf-o"></i> {{ modelService.getString('pdf_download') }}
			</div>
			<div class="col-sm-9"></div>
			<div class="mt-3" id="noFoundPdf" *ngIf="errorPuertaPdf">
				<div  style="color:rgb(237, 215, 235); font-style: italic; height: 24px;">
				{{modelService.getString('door_error_pdf')}}</div>
				</div>
		</div>
<!--ESPRIVISA-36  -->
	</div>
</div>

